import { useQuery } from '@tanstack/react-query';

import { GHADiscountSummaryFilters, getCugLeakSummary } from '~/services/ConnectionGoogleService';

export const cugLeakSummaryQueryKeys = {
  all: ['cugLeakSummary'] as const,
  summary: (filters: GHADiscountSummaryFilters) => [...cugLeakSummaryQueryKeys.all, filters] as const,
};

export function useCugLeakSummary(filters: GHADiscountSummaryFilters = {}) {
  return useQuery({
    queryKey: cugLeakSummaryQueryKeys.summary(filters),
    queryFn: async ({ signal }) => {
      const response = await getCugLeakSummary(filters, { signal });
      return response.result;
    },
  });
}
